<template>
  <div>
    <BreadCrumbs />
    <HoverBox id="f"/>
    <SuccessCase />
    <InformationConsulting />
    <Client />
  </div>
</template>

<script>
import BreadCrumbs from '@/components/home/breadCrumbs'
import HoverBox from '@/components/home/translationService/siderContent-01'
import SuccessCase  from '@/components/home/translationService/siderContent-02'
import InformationConsulting from '@/components/home/translationService/siderContent-03'
import Client from '@/components/home/translationService/siderContent-04'
import { mixin } from '@/mixin/mixin.js'
export default {
  name: 'translation-service',
  components: {
    BreadCrumbs,
    HoverBox,
    SuccessCase,
    InformationConsulting,
    Client
  },
  data () {
    return {
    }
  },
  mixins: [mixin],
}
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/home/translationService/index.vue